import { render, staticRenderFns } from "./ThankYouBlock.vue?vue&type=template&id=8700cab2"
import script from "./ThankYouBlock.vue?vue&type=script&lang=js"
export * from "./ThankYouBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports